// src/components/ProjectModal.js
import React, { useEffect, useState } from 'react';
import { Modal, Form, Input, Select, Checkbox, Button, Row, Col, Radio, notification, DatePicker } from 'antd';
import { climates, countries_List, diameters, externalEquipments, inspectionTypes, materials, positions, powerSupplies, rootBeadTypes, saleContracts, terrains, types, weldingProcesses, wireTypes } from './DatabseList';
import { AddOrUpdateProject, getCategoryListFromDatabse } from '../../../redux/Trackrecord/saga';
import moment from 'moment';
import { EditFilled } from '@ant-design/icons';
const { Option } = Select;

const ProjectModal = (props) => {

    const {
        isModalVisible,
        onClose,
        setIsModalVisible,
        projectDetailForm,
        isEdit,
        setIsEdit,
        editRecord,
        onfetchList,
        userName
    } = props;
    // const [form] = Form.useForm();
    //const [formData, setFormData] = useState({});
    const [addLoding, setAddLaoding] = useState(false)
    const [data_List, setData_List] = useState({})
    const [startedYear, setStartedYear] = useState(moment('YYYY'))
    const [formData, setFormData] = useState({
        year: '',
        equipmentType: '',
        projectNo: '',
        contractor: '',
        client: '',
        project: '',
        duration: '',
        dia: '',
        fjcDetails: '',
        fjcDetails2: '',
        joints: '',
        lengthKm: '',
        coatingThickness: '',
        operatingTemp: '',
        waterDepth: '',
        barge: '',
        location: '',
        type: '',
        coatingMaterial: '',
        pipeMaterial: '',
        cwcThickness: '',
        mouldSystem: '',
        cmpp: '',
        fbe: '',
        wallThickness: '',
        cutbackLength: '',
        fbeToe: '',
        coatingThicknessFbe: '',
        coatingThicknessCmpp: '',
        coatingThicknessImpp: '',
        Units: {
            length: "KM",
            wt1: 'mm',
            wt2: "mm",
            wt3: "mm",
            wt4: "mm"
        }
    });
    useEffect(() => {


        (async () => {
            const response = await getCategoryListFromDatabse()
            //countries_List  =response.countries_List
            if (Object.keys(setData_List).length == 0 && response) {
                setData_List(response)
                //console.log('Record Item', response)
            }
        })();

    }, [])
    const handleOk = async () => {
        // projectDetailForm.validateFields().then(async (values) => {
        //     // console.log(values)
        //     // setAddLaoding(true)

        //     // setAddLaoding(false)
        //     // setFormData(values);


        // });
        if (formData['project'] == '') {
            notification.warning({
                message: 'Enter the Project  to proceed!'
            });
            return;
        }
        if (isEdit) {
            formData['ID'] = editRecord.ID
            formData['created_date'] = moment().format('YYYY-MM-DD').toString()
        }
        else {

            formData['created_date'] = moment().format('YYYY-MM-DD').toString()
        }
        formData['created_by'] = userName ?? ''
        //console.log('Record Item', formData)

        const unit = getCategoryUnitsValue1('length')
        if (unit === 'Miles' && formData.lengthKM != '') {
            //convertion of milesToKm
            const originalValue = Number(formData.lengthKM);
            const lengthKM = (originalValue * factorKM).toFixed(3);
            formData.lengthKM = lengthKM
            formData.lengthMiles = originalValue
            // console.log(formData.lengthKM)
        }
        else {
            //convertion of KM to miles
            const originalValue = Number(formData.lengthKM);
            const lengthMiles = (originalValue * factorMiles).toFixed(3);
            formData.lengthMiles = lengthMiles

        }
        console.log('Project data', formData)
        formData['isEdit'] = isEdit

        setAddLaoding(true)
        await AddOrUpdateProject(formData)
        setAddLaoding(false)
        setIsEdit(false)
        setIsModalVisible(false);
        await onfetchList()
    };
    // useEffect(() => {
    //     console.log(formData)

    // }, [formData])
    useEffect(() => {
        if (isEdit && editRecord) {

            if (!editRecord.Units) {
                editRecord.Units = formData.Units

            }
            setFormData(editRecord)
        }
        else {
            setFormData(formData)
            projectDetailForm.resetFields();

        }
        //console.log(isEdit, formData)

    }, [isEdit])

    const handleCancel = () => {
        projectDetailForm.resetFields();
        setIsEdit(false)

        setFormData({})
        onClose();
        setIsModalVisible(false)

    };
    const onValuesChange = (changedValues, allValues) => {
        // const edited = { ...formData };

        // Object.keys(changedValues).forEach((key) => {
        //     edited[key] = allValues;
        // }); 
        // console.log(allValues)
        // setEditedFields(edited);
        // setIsInputfeildChanged(true)
        //console.log(sortByPropertyAlpha(types,'type'));
        //console.log('Record Item',countries_List)
    };
    const sortByPropertyAlpha = (arr, property, order = 'asc') => {
        return arr.sort((a, b) => {
            if (order === 'asc') {
                return a[property].localeCompare(b[property]);
            } else {
                return b[property].localeCompare(a[property]);
            }
        });
    }

    const handleInputChange = (name, value) => {
        // if (name === 'trailDate')
        //     value = moment(value).format('YYYY-MM-DD');



        setFormData((prevData) => ({ ...prevData, [name]: value }));

    };
    const handleInputDateChange = (name, value) => {
        // if (name === 'trailDate')
        //     value = moment(value).format('YYYY-MM-DD');

       // console.log(value)

        setFormData((prevData) => ({ ...prevData, [name]: value }));

    };
    const factorMiles = 0.621371;
    const factorKM = 1.609344
    const handleLengthInputChange = (name, value) => {
        //   const unit =   getCategoryUnitsValue1('length')
        //   console.log(name,value,unit)
        //   if(unit ==='Miles')
        //   {
        //     //convertion of milesToKm
        //     const originalValue = Number(value);
        //     value = (originalValue * factorKM).toFixed(3); 
        //     console.log(value)
        //   }

        handleInputChange(name, value)

    }
    const getCategoryValue1 = (type) => {

        if (formData.hasOwnProperty(type)) { // Check if the category exists in selectedOptions
            return formData[type]; // Return the value for the category
        } else {
            return 'no'; // Return null if the category does not exist
        }
    };
    const handleUnitsChange = (type, value) => {
        //setIsInputfeildChanged(true)
        const category = 'Units'
        setFormData((prevOptions) => {
            const updatedCategory = { ...prevOptions[category] };
            updatedCategory[type] = value;


            return {
                ...prevOptions,
                [category]: updatedCategory,
            };
        });
    }

    const getCategoryUnitsValue1 = (type) => {
        const category = 'Units'
        if (formData.hasOwnProperty(category)) { // Check if the category exists in selectedOptions
            return formData[category][type]; // Return the value for the category
        } else {
            return type == 'length' ? 'KM' : 'no'; // Return null if the category does not exist
        }
    };
    return (
        <Modal
            width={1400}
            visible={isModalVisible}
            title="Global Project List"
            className="trackrecord-modal Tracker-modal"
            // onOk={handleOk}
            //onCancel={handleCancel}
            footer={[
                <Button key="back" onClick={handleCancel}>
                    Cancel
                </Button>,
                <Button key="submit" type="primary" onClick={handleOk} loading={addLoding}>
                    {isEdit ? 'Update' : 'Submit'}
                </Button>,
            ]}
        >
            <Form form={projectDetailForm}
                name="project_form"
                layout="vertical"
                autoComplete="off"
                getcontainer={false}
                onValuesChange={onValuesChange}
                width={1400}
            >
                {/* Basic Information Group */}
                <Row gutter={24}>
                    <Col lg={24}>
                        <div style={{ marginBottom: '10px' }}>
                            <div className='heatp-bottom-border'>
                                Basic Information
                            </div>
                        </div>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="year" label="Year">
                            <DatePicker
                                picker="year"
                                style={{ width: '100%' }}
                                value={formData.year ? moment(formData.year, 'YYYY') : null}
                                onChange={(date, dateString) => handleInputDateChange('year', dateString)}
                                format="YYYY"
                                placeholder="Select year"
                            />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="equipmentType" label="Equipment Type">
                            <Input onChange={(e) => handleInputChange('equipmentType', e.target.value)} size="large" placeholder="Enter equipment type" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="projectNo" label="Project Number">
                            <Input onChange={(e) => handleInputChange('projectNo', e.target.value)} size="large" placeholder="Enter project number" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="contractor" label="Contractor">
                            <Input onChange={(e) => handleInputChange('contractor', e.target.value)} size="large" placeholder="Enter contractor name" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="client" label="Client">
                            <Input onChange={(e) => handleInputChange('client', e.target.value)} size="large" placeholder="Enter client name" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="project" label="Project">
                            <Input onChange={(e) => handleInputChange('project', e.target.value)} size="large" placeholder="Enter project name" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="duration" label="Duration">
                            <Input onChange={(e) => handleInputChange('duration', e.target.value)} size="large" placeholder="Enter duration" />
                        </Form.Item>
                    </Col>
                </Row>

                {/* Technical Specifications Group */}
                <Row gutter={24}>
                    <Col lg={24}>
                        <div style={{ marginBottom: '10px' }}>
                            <div className='heatp-bottom-border'>
                                Technical Specifications
                            </div>
                        </div>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="dia" label="Diameter">
                            <Input onChange={(e) => handleInputChange('dia', e.target.value)} size="large" placeholder="Enter diameter" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="fjcDetails" label="FJC Details">
                            <Input onChange={(e) => handleInputChange('fjcDetails', e.target.value)} size="large" placeholder="Enter FJC details" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="fjcDetails2" label="FJC Details 2">
                            <Input onChange={(e) => handleInputChange('fjcDetails2', e.target.value)} size="large" placeholder="Enter additional FJC details" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="joints" label="Joints">
                            <Input onChange={(e) => handleInputChange('joints', e.target.value)} size="large" placeholder="Enter number of joints" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="lengthKm" label="Length (KM)">
                            <Input onChange={(e) => handleInputChange('lengthKm', e.target.value)} size="large" type="number" placeholder="Enter length in KM" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="coatingThickness" label="Coating Thickness">
                            <Input onChange={(e) => handleInputChange('coatingThickness', e.target.value)} size="large" type="number" placeholder="Enter coating thickness" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="operatingTemp" label="Operating Temperature">
                            <Input onChange={(e) => handleInputChange('operatingTemp', e.target.value)} size="large" type="number" placeholder="Enter operating temperature" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="waterDepth" label="Water Depth">
                            <Input onChange={(e) => handleInputChange('waterDepth', e.target.value)} size="large" type="number" placeholder="Enter water depth" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="barge" label="Barge">
                            <Input onChange={(e) => handleInputChange('barge', e.target.value)} size="large" placeholder="Enter barge details" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="location" label="Location">
                            <Input onChange={(e) => handleInputChange('location', e.target.value)} size="large" placeholder="Enter location" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="type" label="Type">
                            <Input onChange={(e) => handleInputChange('type', e.target.value)} size="large" placeholder="Enter type" />
                        </Form.Item>
                    </Col>
                </Row>

                {/* Material Information Group */}
                <Row gutter={24}>
                    <Col lg={24}>
                        <div style={{ marginBottom: '10px' }}>
                            <div className='heatp-bottom-border'>
                                Material Information
                            </div>
                        </div>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="coatingMaterial" label="Coating Material">
                            <Input onChange={(e) => handleInputChange('coatingMaterial', e.target.value)} size="large" placeholder="Enter coating material" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="pipeMaterial" label="Pipe Material">
                            <Input onChange={(e) => handleInputChange('pipeMaterial', e.target.value)} size="large" placeholder="Enter pipe material" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="cwcThickness" label="CWC Thickness">
                            <Input onChange={(e) => handleInputChange('cwcThickness', e.target.value)} size="large" type="number" placeholder="Enter CWC thickness" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="mouldSystem" label="Mould System">
                            <Input onChange={(e) => handleInputChange('mouldSystem', e.target.value)} size="large" placeholder="Enter mould system" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="cmpp" label="CMPP">
                            <Input onChange={(e) => handleInputChange('cmpp', e.target.value)} size="large" placeholder="Enter CMPP details" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="fbe" label="FBE">
                            <Input onChange={(e) => handleInputChange('fbe', e.target.value)} size="large" placeholder="Enter FBE details" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="wallThickness" label="Wall Thickness">
                            <Input onChange={(e) => handleInputChange('wallThickness', e.target.value)} size="large" type="number" placeholder="Enter wall thickness" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="cutbackLength" label="Cutback Length">
                            <Input onChange={(e) => handleInputChange('cutbackLength', e.target.value)} size="large" type="number" placeholder="Enter cutback length" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="fbeToe" label="FBE Toe">
                            <Input onChange={(e) => handleInputChange('fbeToe', e.target.value)} size="large" type="number" placeholder="Enter FBE toe" />
                        </Form.Item>
                    </Col>
                </Row>

                {/* Coating Thickness Details Group */}
                <Row gutter={24}>
                    <Col lg={24}>
                        <div style={{ marginBottom: '10px' }}>
                            <div className='heatp-bottom-border'>
                                Coating Thickness Details
                            </div>
                        </div>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="coatingThicknessFbe" label="Coating Thickness FBE">
                            <Input onChange={(e) => handleInputChange('coatingThicknessFbe', e.target.value)} size="large" type="number" placeholder="Enter FBE coating thickness" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="coatingThicknessCmpp" label="Coating Thickness CMPP">
                            <Input onChange={(e) => handleInputChange('coatingThicknessCmpp', e.target.value)} size="large" type="number" placeholder="Enter CMPP coating thickness" />
                        </Form.Item>
                    </Col>
                    <Col lg={5}>
                        <Form.Item name="coatingThicknessImpp" label="Coating Thickness IMPP">
                            <Input onChange={(e) => handleInputChange('coatingThicknessImpp', e.target.value)} size="large" type="number" placeholder="Enter IMPP coating thickness" />
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Modal>
    );
};

export default ProjectModal;
